<template>
  <div class="data_brain_wrap hidden-xs-only">
    <div class="brain_title">全链智控，数造未来</div>
    <div class="brain_desc">一站式数字化制造服务，让效率与质量双擎驱动 <span @click="$router.push('/ProductCenter').catch(() => {})">查看更多<i class="el-icon-arrow-right"></i></span></div>

    <el-row class="card_wrap " type="flex">
      <el-col
        class="brain_item"
        :span="7"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_bg"></div>
        <el-row style="z-index: 2">
          <el-col :span="6">
            <img :src="item.src" alt="" class="img_item"/>
          </el-col>
          <el-col :span="18" class="con">
            <div class="item_title">{{ item.title }}</div>
            <div class="item_desc"><i class="el-icon-check"></i>{{ item.desc1 }}</div>
            <div class="item_desc"><i class="el-icon-check"></i>{{ item.desc2 }}</div>
            <div class="item_desc"><i class="el-icon-check"></i>{{ item.desc3 }}</div>
          </el-col>
        </el-row>

<!--        <div class="item_title">{{ item.title }}</div>-->
<!--        <div class="item_desc">{{ item.desc }}</div>-->
<!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
<!--        <div class="item_bg"></div>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          src: require('@/assets/img/item/item1.svg'),
          title: '协同层（外部生态集层）',
          desc1: 'SRM—供应商关系管理',
          desc2: 'CRM—客户关系管理',
          desc3: 'SCM—供应链管理',
        },
        {
          src: require('@/assets/img/item/item2.svg'),
          title: '企业层（战略与资源管理）',
          desc1: 'ERP—企业资源计划',
          desc2: 'PLM—产品生命周期管理',
          desc3: 'APS—高级计划排程 ',
        },
        {
          src: require('@/assets/img/item/item3.svg'),
          title: '管控层（生产与运营执行）',
          desc1: 'MES—制造执行系统',
          desc2: 'WMS—仓库管理系统',
          desc3: 'QMS—质量管理系统',
        },
        {
          src: require('@/assets/img/item/item4.svg'),
          title: '现场层（设备与物流控制）',
          desc1: 'PLC控制器',
          desc2: '工业传感器',
          desc3: '无人值守计量节点',
        },
        {
          src: require('@/assets/img/item/item5.svg'),
          title: '决策层（数据驱动决策）',
          desc1: '数据中台',
          desc2: '大数据分析平台',
          desc3: 'AI模型库',
        },
        {
          src: require('@/assets/img/item/item6.svg'),
          title: '基础设施层（硬件支撑）',
          desc1: '机房基础建设',
          desc2: '网络运维管理',
          desc3: '数据存储',
        },
      ],
    }
  },
  methods:{
    handleNavigate(){
      this.$router.push('/ProductCenter').catch((v) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 10px 0 60px 0;
  background: #F5F7FA;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 33px;
    font-weight: bold;
    padding: 40px 0 10px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    //color: rgba(32, 48, 64, 0.75);
    font-size: 14px;
    letter-spacing: 1px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
    span{
      margin-left: 10px;color:#0052D9; letter-spacing: 0;cursor: pointer;
    }
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 20px 5px;
      //background: #fff;
      border-radius: 4px;
      border: 2px solid #fff;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
      margin-top: 40px;
      position: relative;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      .img_item {
        margin-top: 10px;
        width: 90% ;
      }
      &:hover{
        box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
      }
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
        //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
        opacity: 0;
        transition: all 0.5s;
        border-radius: 4px;
        z-index: 1;
        border: 1px solid #fff;
      }
      &:hover .item_bg{
        opacity: 1;
      }
      &:hover .item_title {
        color: #0052D9;
      }
      //&:hover .item_desc {
      //  color: #0052D9;
      //}
      .item_title {
        transition: all 0.5s;
        font-size: 18px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 10px 0 10px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height:30px;
        z-index: 2;
        position: inherit;
        font-size: 13px;
        min-height: 30px;
        i{
          padding-right: 5px;
          color: #19B21E;
          font-weight: bold
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
.con{
  padding-left: 18px;
}
</style>